import React from 'react';
import PropTypes from 'prop-types';
import {Link as RouterLink} from "react-router-dom";

const Link = ({item, onHover, selected, title}) => (
    <RouterLink to={`/${item}`} className={'hoowy'}>
        <div onMouseEnter={() => onHover(item)}
             onMouseLeave={() => onHover('')}
             style={{
                 ...styles.container,
                 backgroundColor: selected ? '#e4195f' : 'rgba(176, 224, 234, .25)',
                 color: selected ? '#ffffff' : '#003d4c',
             }}>
            {title}
        </div>
    </RouterLink>
);

Link.propTypes = {
    onHover: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    item: PropTypes.string.isRequired,
};

const styles = {
    link: {
        textDecoration: 'none',
    },
    container: {
        cursor: 'pointer',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '20px',
        lineHeight: '36px',
        textTransform: 'uppercase',
        marginBottom: '15px',

        border: '2px solid #003D4C',
        borderRadius: '12px',
        padding: '10px 40px 10px 40px',
        display: 'flex',
        justifyContent: 'center',

    },
}

export default Link;
